export const profileKeywords = {
  me: 'me',
  newUser: 'new-user',
};
